export default [
  {
    title: 'My reservations',
    route: 'home',
    icon: 'CalendarIcon',
  },
  {
    title: 'Location Details',
    route: 'account',
    icon: 'UserIcon',
  },
  {
    title: 'My Organization',
    route: 'organization',
    icon: 'GridIcon',
  },
  {
    title: 'Date Availability',
    route: 'preferences',
    icon: 'BriefcaseIcon',
  },
  {
    title: 'Blocked days',
    route: 'blocked-days',
    icon: 'SlashIcon',
  },
  {
    title: 'My reviews',
    route: 'reviews',
    icon: 'StarIcon',
  },
]
